import { render, staticRenderFns } from "./general.vue?vue&type=template&id=b0cc1da8&"
import script from "./general.vue?vue&type=script&lang=ts&"
export * from "./general.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports